import "core-js/modules/es.array.reverse.js";
var _class, _ImageServerStratum, _class2, _ImageServerLegendStratum, _class3, _ArcGisImageServerCatalogItem;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import i18next from "i18next";
import uniqWith from "lodash-es/uniqWith";
import { computed, makeObservable, override, runInAction } from "mobx";
import GeographicTilingScheme from "terriajs-cesium/Source/Core/GeographicTilingScheme";
import JulianDate from "terriajs-cesium/Source/Core/JulianDate";
import WebMercatorTilingScheme from "terriajs-cesium/Source/Core/WebMercatorTilingScheme";
import URI from "urijs";
import AsyncLoader from "../../../Core/AsyncLoader";
import { isJsonObject } from "../../../Core/Json";
import TerriaError from "../../../Core/TerriaError";
import createDiscreteTimesFromIsoSegments from "../../../Core/createDiscreteTimes";
import createTransformerAllowUndefined from "../../../Core/createTransformerAllowUndefined";
import filterOutUndefined from "../../../Core/filterOutUndefined";
import isDefined from "../../../Core/isDefined";
import loadJson from "../../../Core/loadJson";
import replaceUnderscores from "../../../Core/replaceUnderscores";
import { scaleDenominatorToLevel } from "../../../Core/scaleToDenominator";
import ArcGisImageServerImageryProvider from "../../../Map/ImageryProvider/ArcGisImageServerImageryProvider";
import Reproject from "../../../Map/Vector/Reproject";
import CatalogMemberMixin from "../../../ModelMixins/CatalogMemberMixin";
import DiscretelyTimeVaryingMixin from "../../../ModelMixins/DiscretelyTimeVaryingMixin";
import MappableMixin from "../../../ModelMixins/MappableMixin";
import MinMaxLevelMixin from "../../../ModelMixins/MinMaxLevelMixin";
import UrlMixin from "../../../ModelMixins/UrlMixin";
import ArcGisImageServerCatalogItemTraits, { ArcGisImageServerAvailableRasterFunctionTraits, ArcGisImageServerRenderingRule } from "../../../Traits/TraitsClasses/ArcGisImageServerCatalogItemTraits";
import LegendTraits, { LegendItemTraits } from "../../../Traits/TraitsClasses/LegendTraits";
import CreateModel from "../../Definition/CreateModel";
import LoadableStratum from "../../Definition/LoadableStratum";
import StratumOrder from "../../Definition/StratumOrder";
import createStratumInstance from "../../Definition/createStratumInstance";
import getToken from "../../getToken";
import proxyCatalogItemUrl from "../proxyCatalogItemUrl";
import { getRectangleFromLayer } from "./ArcGisMapServerCatalogItem";
let ImageServerStratum = (_class = (_ImageServerStratum = class ImageServerStratum extends LoadableStratum(ArcGisImageServerCatalogItemTraits) {
  constructor(_item, imageServer, _token) {
    super();
    this._item = _item;
    this.imageServer = imageServer;
    this._token = _token;
    makeObservable(this);
  }
  duplicateLoadableStratum(newModel) {
    return new ImageServerStratum(newModel, this.imageServer, this._token);
  }
  static async load(item) {
    var _serviceMetadata$capa, _serviceMetadata$full, _serviceMetadata$full2, _serviceMetadata$full3;
    if (!isDefined(item.uri)) {
      throw new TerriaError({
        title: i18next.t("models.arcGisImageServerCatalogItem.invalidUrlTitle"),
        message: i18next.t("models.arcGisImageServerCatalogItem.invalidUrlMessage")
      });
    }
    let token;
    if (isDefined(item.tokenUrl) && isDefined(item.url)) {
      token = await getToken(item.terria, item.tokenUrl, item.url);
    } else if (isDefined(item.token)) {
      token = item.token;
    }
    let serviceUri = getBaseURI(item);
    if (isDefined(token)) {
      serviceUri = serviceUri.addQuery("token", token);
    }
    const serviceMetadata = await getJson(item, serviceUri);
    if (!isDefined(serviceMetadata)) {
      throw new TerriaError({
        title: i18next.t("models.arcGisService.invalidServerTitle"),
        message: i18next.t("models.arcGisService.invalidServerMessage")
      });
    }
    if (!((_serviceMetadata$capa = serviceMetadata.capabilities) !== null && _serviceMetadata$capa !== void 0 && _serviceMetadata$capa.includes("Image"))) throw new TerriaError({
      title: i18next.t("models.arcGisImageServerCatalogItem.invalidServiceTitle"),
      message: i18next.t("models.arcGisImageServerCatalogItem.invalidServiceMessage")
    });

    // Add any Proj4 definitions if necessary
    const epsgCode = (_serviceMetadata$full = (_serviceMetadata$full2 = serviceMetadata.fullExtent.spatialReference) === null || _serviceMetadata$full2 === void 0 ? void 0 : _serviceMetadata$full2.latestWkid) !== null && _serviceMetadata$full !== void 0 ? _serviceMetadata$full : (_serviceMetadata$full3 = serviceMetadata.fullExtent.spatialReference) === null || _serviceMetadata$full3 === void 0 ? void 0 : _serviceMetadata$full3.wkid;
    if (epsgCode && item.terria.configParameters.proj4ServiceBaseUrl) {
      await Reproject.checkProjection(item.terria.configParameters.proj4ServiceBaseUrl, "EPSG:".concat(epsgCode));
    }
    const stratum = new ImageServerStratum(item, serviceMetadata, token);
    return stratum;
  }
  get name() {
    return replaceUnderscores(this.imageServer.name);
  }
  get cacheDuration() {
    return "1d";
  }
  get rectangle() {
    const rectangle = {
      west: Infinity,
      south: Infinity,
      east: -Infinity,
      north: -Infinity
    };
    getRectangleFromLayer(this.imageServer.fullExtent, rectangle);
    if (rectangle.west === Infinity || rectangle.south === Infinity || rectangle.east === -Infinity || rectangle.north === -Infinity) return undefined;
    return rectangle;
  }
  get description() {
    return this.imageServer.description;
  }
  get attribution() {
    return this.imageServer.copyrightText;
  }
  get token() {
    return this._token;
  }

  /** Disable pre-cached tiles if we are making dynamic requests - using parameters, time or rendering rule. */
  get usePreCachedTiles() {
    if (this._item.parameters || this._item.currentDiscreteJulianDate || this._item.renderingRule.rasterFunction) return false;

    // We only support web mercator or wgs84
    if (isDefined(this.imageServer.tileInfo)) {
      var _this$imageServer$til, _this$imageServer$til2, _this$imageServer$til3;
      const wkid = (_this$imageServer$til = (_this$imageServer$til2 = this.imageServer.tileInfo.spatialReference) === null || _this$imageServer$til2 === void 0 ? void 0 : _this$imageServer$til2.latestWkid) !== null && _this$imageServer$til !== void 0 ? _this$imageServer$til : (_this$imageServer$til3 = this.imageServer.tileInfo.spatialReference) === null || _this$imageServer$til3 === void 0 ? void 0 : _this$imageServer$til3.wkid;
      if (wkid === 102100 || wkid === 102113 || wkid === 3857 || wkid === 4326) return true;
    }
    return false;
  }

  /** Override wkid to web mercator if using pre-cached tiles (and web mercator is supported) */
  get wkid() {
    if (this._item.usePreCachedTiles) {
      var _this$imageServer$til4;
      const wkid = (_this$imageServer$til4 = this.imageServer.tileInfo) === null || _this$imageServer$til4 === void 0 ? void 0 : _this$imageServer$til4.spatialReference.wkid;
      if (wkid === 102100 || wkid === 102113 || wkid === 3857 || wkid === 4326) return wkid;
    }
  }
  get tileHeight() {
    var _this$imageServer$til5;
    if (this._item.usePreCachedTiles) return (_this$imageServer$til5 = this.imageServer.tileInfo) === null || _this$imageServer$til5 === void 0 ? void 0 : _this$imageServer$til5.rows;
  }
  get tileWidth() {
    var _this$imageServer$til6;
    if (this._item.usePreCachedTiles) return (_this$imageServer$til6 = this.imageServer.tileInfo) === null || _this$imageServer$til6 === void 0 ? void 0 : _this$imageServer$til6.cols;
  }
  get maximumScale() {
    return this.imageServer.maxScale;
  }
  get maximumLevel() {
    var _this$imageServer$til7;
    const maximumLevelFromScale = scaleDenominatorToLevel(this._item.maximumScale, true, false);

    // Make sure the maximum level is not higher than the maximum level of the server tiles
    if (this._item.usePreCachedTiles && (_this$imageServer$til7 = this.imageServer.tileInfo) !== null && _this$imageServer$til7 !== void 0 && _this$imageServer$til7.lods) return Math.min(this.imageServer.tileInfo.lods[this.imageServer.tileInfo.lods.length - 1].level, maximumLevelFromScale !== null && maximumLevelFromScale !== void 0 ? maximumLevelFromScale : Infinity);
    return maximumLevelFromScale;
  }
  get minimumLevel() {
    var _this$imageServer$til8;
    if (this._item.usePreCachedTiles && (_this$imageServer$til8 = this.imageServer.tileInfo) !== null && _this$imageServer$til8 !== void 0 && _this$imageServer$til8.lods) return this.imageServer.tileInfo.lods[0].level;
  }
  get allowRasterFunction() {
    return this.imageServer.allowRasterFunction;
  }
  get availableRasterFunctions() {
    var _this$imageServer;
    if (!this._item.allowRasterFunction) return [];
    return (_this$imageServer = this.imageServer) === null || _this$imageServer === void 0 ? void 0 : _this$imageServer.rasterFunctionInfos.filter(rasterFn => rasterFn.name && rasterFn.name !== "None").map(rasterFn => {
      return createStratumInstance(ArcGisImageServerAvailableRasterFunctionTraits, {
        name: rasterFn.name,
        description: rasterFn.description !== "A raster function template." ? rasterFn.description : undefined,
        help: rasterFn.help
      });
    });
  }
  get disableRasterFunctionSelectors() {
    return !this._item.allowRasterFunction;
  }
}, _defineProperty(_ImageServerStratum, "stratumName", "arcgisImageserver"), _ImageServerStratum), _applyDecoratedDescriptor(_class.prototype, "usePreCachedTiles", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "usePreCachedTiles"), _class.prototype), _class);
StratumOrder.addLoadStratum(ImageServerStratum.stratumName);
let ImageServerLegendStratum = (_class2 = (_ImageServerLegendStratum = class ImageServerLegendStratum extends LoadableStratum(ArcGisImageServerCatalogItemTraits) {
  constructor(_item, _legends) {
    super();
    this._item = _item;
    this._legends = _legends;
    makeObservable(this);
  }
  duplicateLoadableStratum(newModel) {
    return new ImageServerLegendStratum(newModel, this._legends);
  }
  static async load(item) {
    if (!isDefined(item.uri)) {
      throw new TerriaError({
        title: i18next.t("models.arcGisImageServerCatalogItem.invalidUrlTitle"),
        message: i18next.t("models.arcGisImageServerCatalogItem.invalidUrlMessage")
      });
    }
    let legendUri = getBaseURI(item).segment("legend");
    legendUri.addQuery(item.flattenedParameters);

    // Note we don't need to fetch token from tokenUrl here - as ImageServerStratum handles that, and will populate `token` trait with the response
    if (isDefined(item.token)) {
      legendUri = legendUri.addQuery("token", item.token);
    }
    const legendMetadata = await getJson(item, legendUri);
    const stratum = new ImageServerLegendStratum(item, legendMetadata);
    return stratum;
  }
  get legends() {
    var _this$_legends;
    const noDataRegex = /^No[\s_-]?Data$/i;
    const labelsRegex = /_Labels$/;
    let items = [];
    (((_this$_legends = this._legends) === null || _this$_legends === void 0 ? void 0 : _this$_legends.layers) || []).forEach(l => {
      var _l$legend;
      if (noDataRegex.test(l.layerName) || labelsRegex.test(l.layerName)) {
        return;
      }
      (_l$legend = l.legend) === null || _l$legend === void 0 || _l$legend.forEach(leg => {
        const title = replaceUnderscores(leg.label !== "" ? leg.label : l.layerName);
        const dataUrl = "data:" + leg.contentType + ";base64," + leg.imageData;
        items.push(createStratumInstance(LegendItemTraits, {
          title,
          imageUrl: dataUrl,
          imageWidth: leg.width,
          imageHeight: leg.height
        }));
      });
    });
    items = uniqWith(items, (a, b) => a.imageUrl === b.imageUrl);
    return [createStratumInstance(LegendTraits, {
      items
    })];
  }
}, _defineProperty(_ImageServerLegendStratum, "stratumName", "arcgisImageserverLegend"), _ImageServerLegendStratum), _applyDecoratedDescriptor(_class2.prototype, "legends", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "legends"), _class2.prototype), _class2);
StratumOrder.addLoadStratum(ImageServerLegendStratum.stratumName);
let ArcGisImageServerCatalogItem = (_class3 = (_ArcGisImageServerCatalogItem = class ArcGisImageServerCatalogItem extends UrlMixin(DiscretelyTimeVaryingMixin(MinMaxLevelMixin(CatalogMemberMixin(MappableMixin(CreateModel(ArcGisImageServerCatalogItemTraits)))))) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "_legendStratumLoader", new AsyncLoader(this.forceLoadLegends.bind(this)));
    _defineProperty(this, "_createImageryProvider", createTransformerAllowUndefined(time => {
      var _this$attribution;
      if (!isDefined(this.url)) {
        return undefined;
      }
      const params = _objectSpread({}, this.flattenedParameters);
      if (time) params.time = JulianDate.toDate(time).getTime();
      let tilingScheme;
      if (this.wkid === 102100 || this.wkid === 102113 || this.wkid === 3857) {
        tilingScheme = new WebMercatorTilingScheme();
      } else if (this.wkid === 4326) {
        tilingScheme = new GeographicTilingScheme();
      } else {
        throw TerriaError.from("Tile spatial reference WKID ".concat(this.wkid, " is not supported."));
      }
      return new ArcGisImageServerImageryProvider({
        url: cleanAndProxyUrl(this, this.url),
        tilingScheme: tilingScheme,
        maximumLevel: this.maximumLevel,
        minimumLevel: this.minimumLevel,
        tileHeight: this.tileHeight,
        tileWidth: this.tileWidth,
        parameters: params,
        enablePickFeatures: this.allowFeaturePicking,
        usePreCachedTiles: this.usePreCachedTiles,
        token: this.token,
        credit: (_this$attribution = this.attribution) !== null && _this$attribution !== void 0 ? _this$attribution : ""
      });
    }));
    makeObservable(this);
  }
  get typeName() {
    return i18next.t("models.arcGisImageServerCatalogItem.name");
  }
  get type() {
    return ArcGisImageServerCatalogItem.type;
  }
  async forceLoadMetadata() {
    const stratum = await ImageServerStratum.load(this);
    runInAction(() => {
      this.strata.set(ImageServerStratum.stratumName, stratum);
    });
    await this._legendStratumLoader.load();
  }
  async forceLoadLegends() {
    const stratum = await ImageServerLegendStratum.load(this);
    runInAction(() => {
      this.strata.set(ImageServerLegendStratum.stratumName, stratum);
    });
  }
  forceLoadMapItems() {
    return Promise.resolve();
  }
  get discreteTimes() {
    const imageServerStratum = this.strata.get(ImageServerStratum.stratumName);
    if ((imageServerStratum === null || imageServerStratum === void 0 ? void 0 : imageServerStratum.imageServer.timeInfo) === undefined) return undefined;
    const result = [];
    createDiscreteTimesFromIsoSegments(result, new Date(imageServerStratum.imageServer.timeInfo.timeExtent[0]).toISOString(), new Date(imageServerStratum.imageServer.timeInfo.timeExtent[1]).toISOString(), undefined, this.maxRefreshIntervals);
    return result;
  }
  get _currentImageryParts() {
    // Make sure legend stays up to date
    this._legendStratumLoader.load();
    const imageryProvider = this._createImageryProvider(this.currentDiscreteJulianDate);
    if (imageryProvider) {
      return {
        imageryProvider,
        alpha: this.opacity,
        show: this.show,
        clippingRectangle: this.clipToRectangle ? this.cesiumRectangle : undefined
      };
    }
  }
  get _nextImageryParts() {
    if (this.terria.timelineStack.contains(this) && !this.isPaused && this.nextDiscreteTimeTag) {
      const imageryProvider = this._createImageryProvider(this.nextDiscreteJulianDate);
      if (imageryProvider) {
        imageryProvider.enablePickFeatures = false;
        return {
          imageryProvider,
          alpha: 0.0,
          show: true,
          clippingRectangle: this.clipToRectangle ? this.cesiumRectangle : undefined
        };
      }
    } else {
      return undefined;
    }
  }

  /** Flatten nested JSON parameters (stringify them). These are applied onto ArcGisImageServerImageryProvider requests.
   * This will include renderingRule and bandIds if they are set.
   */
  get flattenedParameters() {
    var _this$parameters;
    const params = Object.entries((_this$parameters = this.parameters) !== null && _this$parameters !== void 0 ? _this$parameters : {}).reduce((acc, _ref) => {
      let [key, value] = _ref;
      if (isJsonObject(value)) acc[key] = JSON.stringify(value);else acc[key] = value;
      return acc;
    }, {});
    if (this.renderingRule.rasterFunction) params.renderingRule = JSON.stringify(this.traits["renderingRule"].toJson(this.renderingRule));
    if (this.bandIds) params.bandIds = this.bandIds.join(",");
    return params;
  }
  get mapItems() {
    if (this.isLoadingMetadata) return [];
    return [this._currentImageryParts, this._nextImageryParts].filter(isDefined);
  }
  get selectableDimensions() {
    return filterOutUndefined([...super.selectableDimensions, this.rasterFunctionSelectableDimensions]);
  }
  get rasterFunctionSelectableDimensions() {
    var _this$renderingRule;
    if (this.disableRasterFunctionSelectors) return undefined;
    return {
      id: "raster-functions",
      name: i18next.t("models.arcGisImageServerCatalogItem.rasterFunction"),
      options: this.availableRasterFunctions.map(rasterFn => ({
        id: rasterFn.name,
        name: rasterFn.name,
        description: rasterFn.description
      })),
      selectedId: (_this$renderingRule = this.renderingRule) === null || _this$renderingRule === void 0 ? void 0 : _this$renderingRule.rasterFunction,
      allowUndefined: true,
      undefinedLabel: "Default",
      setDimensionValue: (strata, rasterFunction) => {
        if (!this.renderingRule) {
          this.setTrait(strata, "renderingRule", createStratumInstance(ArcGisImageServerRenderingRule, {
            rasterFunction
          }));
        } else {
          this.renderingRule.setTrait(strata, "rasterFunction", rasterFunction);
        }
      }
    };
  }
}, _defineProperty(_ArcGisImageServerCatalogItem, "type", "esri-imageServer"), _ArcGisImageServerCatalogItem), _applyDecoratedDescriptor(_class3.prototype, "discreteTimes", [computed], Object.getOwnPropertyDescriptor(_class3.prototype, "discreteTimes"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "_currentImageryParts", [computed], Object.getOwnPropertyDescriptor(_class3.prototype, "_currentImageryParts"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "_nextImageryParts", [computed], Object.getOwnPropertyDescriptor(_class3.prototype, "_nextImageryParts"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "flattenedParameters", [computed], Object.getOwnPropertyDescriptor(_class3.prototype, "flattenedParameters"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "mapItems", [computed], Object.getOwnPropertyDescriptor(_class3.prototype, "mapItems"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "selectableDimensions", [override], Object.getOwnPropertyDescriptor(_class3.prototype, "selectableDimensions"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "rasterFunctionSelectableDimensions", [computed], Object.getOwnPropertyDescriptor(_class3.prototype, "rasterFunctionSelectableDimensions"), _class3.prototype), _class3);
export { ArcGisImageServerCatalogItem as default };
function getBaseURI(item) {
  const uri = new URI(item.url);
  const lastSegment = uri.segment(-1);
  if (lastSegment && lastSegment.match(/\d+/)) {
    uri.segment(-1, "");
  }
  return uri;
}
async function getJson(item, uri) {
  try {
    const response = await loadJson(proxyCatalogItemUrl(item, uri.addQuery("f", "json").toString()));
    return response;
  } catch (err) {
    console.log(err);
    return undefined;
  }
}
function cleanAndProxyUrl(catalogItem, url) {
  return proxyCatalogItemUrl(catalogItem, cleanUrl(url));
}
function cleanUrl(url) {
  // Strip off the search portion of the URL
  const uri = new URI(url);
  uri.search("");
  return uri.toString();
}